<template>
<v-container fluid class="fill-height justify-center">
<v-row>
  <v-col cols="12" sm="6" style="padding: 50px;" >

  <div class="pa-md-16 pa-lg-16 ma-md-16 ma-lg-16">
<img style="width: 70%; padding-bottom: 30px;" src="https://moveitnq.com.au/wp-content/uploads/2022/08/MINQ-ON-DEMAND-MAIN-VUE-SIGN-UP.png"/>
        <h3>Registration Portal</h3>
       <br>

<v-form fluid  v-model="validForm" ref="form" v-if="$store.state.onDemandStatus" >
        <v-row>  
          <v-col fluid cols="12" sm="12">
            <v-text-field required v-model="firstname" :rules="nameRules" label="First Name" placeholder="First Name" outlined ></v-text-field>
            <v-text-field required v-model="surname" :rules="nameRules" label="Surname" placeholder="Surname" outlined ></v-text-field>
            <v-text-field required v-model="email" :rules="emailRules" label="Email" placeholder="Email" outlined ></v-text-field>
            <v-text-field required v-model="age" :rules="digitRules" label="Age" placeholder="Age" outlined ></v-text-field>
            <v-select required :items='gender' :rules="nameRules" v-model="Ugender" label="Gender" outlined dense > </v-select>
            <v-text-field required v-model="postcode" :rules="nameRules" label="Zipcode / Postcode" placeholder="Zip Code" outlined ></v-text-field>
            <v-select required :items='country' :rules="nameRules" v-model="Ucountry" label="Country" outlined dense > </v-select>
            <v-select required v-if="Ucountry === 'Australia'" :rules="nameRules" :items='state' v-model="Ustate" label="State" outlined dense > </v-select>
            <v-select required v-if="Ustate === 'QLD'" :items="lgasAll" :rules="nameRules" v-model="lga" label="Local Council" outlined dense > </v-select>

            <h3>My Lifestye</h3>
            <h5>How I would rate my overall health?</h5> <br><br>
            <v-slider required persistent-hint thumb-label="always" v-model="healthRating" 
            hint="0 being terrible, 10 excellent couldn't be better" max="10" min="0"></v-slider>
            <br>
            <v-select required :items="activity" :rules="nameRules" v-model="currentActivity" label="Current level of physical activity / structured activity per week?" outlined dense > </v-select>
            <v-select required :items="barrier" :rules="nameRules" v-model="currentBarrier" label="What is your main barrier to keeping physically active?" outlined dense > </v-select>

            <v-checkbox v-model="culturalIdentity" :label="`I identify as Aboriginal or Torres Strait Islander`"></v-checkbox>

            <v-checkbox style="margin-top: 0" v-model="terms" :rules="boolRules" required>
              <template v-slot:label>
                <div>
                  I agree to Terms & Conditions and Privacy Policy
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="https://moveitnq.com.au/privacy-policy"
                        @click.stop
                        v-on="on"
                      >
                        Read Now
                      </a>
                    </template>
                    Opens in new window
                  </v-tooltip>
                </div>
              </template>
            </v-checkbox>

          </v-col>
        </v-row>

    <v-alert
  prominent
  text
  type="info"
>The security of your data is our primary concern. We collect this data to better understand and meet community health needs.</v-alert>

<!-- Registration Button -->
<v-btn block color='primary' :disabled="!validForm" @click='register'> PROCEED TO STEP 2 </v-btn>

  </v-form>
  <h3 v-else> Move It NQ Demand Sign Up is currently closed </h3>
</div>

</v-col>


<v-col cols="12" sm="6"  style="background-color: #f1f1f1; background-position: center; background-size: cover;" :style="{backgroundImage:'url(https://moveitnq.com.au/wp-content/uploads/2022/07/Wexer-Sign-Up-Image.jpeg)'}"></v-col>


</v-row>
  </v-container>
</template>


<script>

import {mapState} from 'vuex';
// import axios from 'axios';

export default {
    name:'Registration',
     data: () => ({
      date: '',
         email:'',
         firstname :'',
         surname: '',
         age: 0,
         postcode :0,
         Ugender :'',
         lga: '',
         Ucountry: 'Australia',
         Ustate: '',
         healthRating :0,
         currentActivity :'',
         currentBarrier :'',
         culturalIdentity: false,
         registrationDate: new Date(),
      terms:false,
      activity: ['Never', 'Occasionally but not regularly', '1-2 times a week', '3-4 times a week', '5-7 times a week'],
      barrier: ['Time', 'Work / Family Commitments', 'Financial', 'Motivation', 'Limited access to programs', 'Weather', 'None','Other'],
      gender: ["Male", "Female", "Other"],
      // country: ["Australia"],
      country:  [
	"Afghanistan",
	"Albania",
	"Algeria",
	"American Samoa",
	"Andorra",
	"Angola",
	"Anguilla",
	"Antarctica",
	"Antigua and Barbuda",
	"Argentina",
	"Armenia",
	"Aruba",
	"Australia",
	"Austria",
	"Azerbaijan",
	"Bahamas (the)",
	"Bahrain",
	"Bangladesh",
	"Barbados",
	"Belarus",
	"Belgium",
	"Belize",
	"Benin",
	"Bermuda",
	"Bhutan",
	"Bolivia (Plurinational State of)",
	"Bonaire, Sint Eustatius and Saba",
	"Bosnia and Herzegovina",
	"Botswana",
	"Bouvet Island",
	"Brazil",
	"British Indian Ocean Territory (the)",
	"Brunei Darussalam",
	"Bulgaria",
	"Burkina Faso",
	"Burundi",
	"Cabo Verde",
	"Cambodia",
	"Cameroon",
	"Canada",
	"Cayman Islands (the)",
	"Central African Republic (the)",
	"Chad",
	"Chile",
	"China",
	"Christmas Island",
	"Cocos (Keeling) Islands (the)",
	"Colombia",
	"Comoros (the)",
	"Congo (the Democratic Republic of the)",
	"Congo (the)",
	"Cook Islands (the)",
	"Costa Rica",
	"Croatia",
	"Cuba",
	"Curaçao",
	"Cyprus",
	"Czechia",
	"Côte d'Ivoire",
	"Denmark",
	"Djibouti",
	"Dominica",
	"Dominican Republic (the)",
	"Ecuador",
	"Egypt",
	"El Salvador",
	"Equatorial Guinea",
	"Eritrea",
	"Estonia",
	"Eswatini",
	"Ethiopia",
	"Falkland Islands (the) [Malvinas]",
	"Faroe Islands (the)",
	"Fiji",
	"Finland",
	"France",
	"French Guiana",
	"French Polynesia",
	"French Southern Territories (the)",
	"Gabon",
	"Gambia (the)",
	"Georgia",
	"Germany",
	"Ghana",
	"Gibraltar",
	"Greece",
	"Greenland",
	"Grenada",
	"Guadeloupe",
	"Guam",
	"Guatemala",
	"Guernsey",
	"Guinea",
	"Guinea-Bissau",
	"Guyana",
	"Haiti",
	"Heard Island and McDonald Islands",
	"Holy See (the)",
	"Honduras",
	"Hong Kong",
	"Hungary",
	"Iceland",
	"India",
	"Indonesia",
	"Iran (Islamic Republic of)",
	"Iraq",
	"Ireland",
	"Isle of Man",
	"Israel",
	"Italy",
	"Jamaica",
	"Japan",
	"Jersey",
	"Jordan",
	"Kazakhstan",
	"Kenya",
	"Kiribati",
	"Korea (the Democratic People's Republic of)",
	"Korea (the Republic of)",
	"Kuwait",
	"Kyrgyzstan",
	"Lao People's Democratic Republic (the)",
	"Latvia",
	"Lebanon",
	"Lesotho",
	"Liberia",
	"Libya",
	"Liechtenstein",
	"Lithuania",
	"Luxembourg",
	"Macao",
	"Madagascar",
	"Malawi",
	"Malaysia",
	"Maldives",
	"Mali",
	"Malta",
	"Marshall Islands (the)",
	"Martinique",
	"Mauritania",
	"Mauritius",
	"Mayotte",
	"Mexico",
	"Micronesia (Federated States of)",
	"Moldova (the Republic of)",
	"Monaco",
	"Mongolia",
	"Montenegro",
	"Montserrat",
	"Morocco",
	"Mozambique",
	"Myanmar",
	"Namibia",
	"Nauru",
	"Nepal",
	"Netherlands (the)",
	"New Caledonia",
	"New Zealand",
	"Nicaragua",
	"Niger (the)",
	"Nigeria",
	"Niue",
	"Norfolk Island",
	"Northern Mariana Islands (the)",
	"Norway",
	"Oman",
	"Pakistan",
	"Palau",
	"Palestine, State of",
	"Panama",
	"Papua New Guinea",
	"Paraguay",
	"Peru",
	"Philippines (the)",
	"Pitcairn",
	"Poland",
	"Portugal",
	"Puerto Rico",
	"Qatar",
	"Republic of North Macedonia",
	"Romania",
	"Russian Federation (the)",
	"Rwanda",
	"Réunion",
	"Saint Barthélemy",
	"Saint Helena, Ascension and Tristan da Cunha",
	"Saint Kitts and Nevis",
	"Saint Lucia",
	"Saint Martin (French part)",
	"Saint Pierre and Miquelon",
	"Saint Vincent and the Grenadines",
	"Samoa",
	"San Marino",
	"Sao Tome and Principe",
	"Saudi Arabia",
	"Senegal",
	"Serbia",
	"Seychelles",
	"Sierra Leone",
	"Singapore",
	"Sint Maarten (Dutch part)",
	"Slovakia",
	"Slovenia",
	"Solomon Islands",
	"Somalia",
	"South Africa",
	"South Georgia and the South Sandwich Islands",
	"South Sudan",
	"Spain",
	"Sri Lanka",
	"Sudan (the)",
	"Suriname",
	"Svalbard and Jan Mayen",
	"Sweden",
	"Switzerland",
	"Syrian Arab Republic",
	"Taiwan",
	"Tajikistan",
	"Tanzania, United Republic of",
	"Thailand",
	"Timor-Leste",
	"Togo",
	"Tokelau",
	"Tonga",
	"Trinidad and Tobago",
	"Tunisia",
	"Turkey",
	"Turkmenistan",
	"Turks and Caicos Islands (the)",
	"Tuvalu",
	"Uganda",
	"Ukraine",
	"United Arab Emirates (the)",
	"United Kingdom of Great Britain and Northern Ireland (the)",
	"United States Minor Outlying Islands (the)",
	"United States of America (the)",
	"Uruguay",
	"Uzbekistan",
	"Vanuatu",
	"Venezuela (Bolivarian Republic of)",
	"Viet Nam",
	"Virgin Islands (British)",
	"Virgin Islands (U.S.)",
	"Wallis and Futuna",
	"Western Sahara",
	"Yemen",
	"Zambia",
	"Zimbabwe",
	"Åland Islands"
],
      state: ["QLD", "NSW", "ACT", "SA", "NT", "TAS", "VIC", "WA"],
      dateToday: new Date(),
      menu: false,
      name:'',
      modal: false,
      menu2: false,
      selectedLga:false,
      notes:'',
      instName:'',
      tAttendance:0,
      mAttendance:0,
      validForm:false,
      added:-1,
	emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      nameRules: [
        v => !!v || 'Field is required',
        v => v.length > 1 || 'Cannot be empty',
      ],
      digitRules: [
        v => v > -1 || 'Digit Must Be Greater Then 0',
      ],
	boolRules: [
        v => v  || 'Must be accepted',
      ],
  }),
    components: {
  
  },
  watch:{
      added(value)
      {
          if(value === 1){
                this.$refs.form.resetValidation()
                this.$refs.form.reset()
                setTimeout(() => {
                    this.added = -1
                }, 3000);
          }
          if(value === 0){
                setTimeout(() => {
                    this.added = -1
                }, 3000);
          }
          
      }
  },
  computed:{ ...mapState(['lgasAll','submissions','programs']),
  timeLogged() {
     var d = new Date(this.dateToday);
      d = new Date(d.getTime());
      var date_format_str = d.getFullYear().toString()+"-"+((d.getMonth()+1).toString().length==2?(d.getMonth()+1).toString():"0"+(d.getMonth()+1).toString())+"-"+(d.getDate().toString().length==2?d.getDate().toString():"0"+d.getDate().toString())+" "+(d.getHours().toString().length==2?d.getHours().toString():"0"+d.getHours().toString())+":"+((parseInt(d.getMinutes()/5)*5).toString().length==2?(parseInt(d.getMinutes()/5)*5).toString():"0"+(parseInt(d.getMinutes()/5)*5).toString())+":00";
      return date_format_str
  },
  eventDate() {
     var d = new Date(this.date);
      d = new Date(d.getTime());
      var date_format_str = d.getFullYear().toString()+"-"+((d.getMonth()+1).toString().length==2?(d.getMonth()+1).toString():"0"+(d.getMonth()+1).toString())+"-"+(d.getDate().toString().length==2?d.getDate().toString():"0"+d.getDate().toString());
      date_format_str = date_format_str+' 00:00:00';
      return date_format_str
  },
    programsSet() {
      let data = [];
      this.programs.forEach(element => {
        if(element.LGA === this.selectedLga) data.push(element['Program Name'])
      });
      data = data.filter((c, index) => {
          return data.indexOf(c) === index;
      });
      return data;
  },
    },
    mounted() {
        if(this.$root.isLga){
      this.selectedLga = this.$root.user.LGA
      }else{
          //nothing
      } 
  
    },
    methods:{
      
        async register() {
			let form = this.$refs.form.validate()
			console.log("form", form)
            if(this.validForm){
				// alert("registration passed")
              let programs = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/ondemand");
			let user = {
				email:this.email ,
                firstname:this.firstname  ,
                surname :this.surname ,
                age:this.age ,
                postcode:this.postcode  ,
                gender:this.gender  ,
                country: this.Ucountry ,
                state:this.Ustate ,
                lga :this.lga ,
                healthRating:this.healthRating  ,
                currentActivity:this.currentActivity  ,
                currentBarrier:this.currentBarrier  ,
                culturalIdentity:this.culturalIdentity ,
                registrationDate:this.registrationDate,
			}
              user.registrationDate = user.registrationDate.toString() 
			console.log("user data", user)

              await programs.push(user)
              let url = `https://ondemand.moveitnq.com.au/signup?firstname=${user.firstname}&lastname=${user.surname}&email=${user.email}`
              window.open(url,'_self').focus();
                this.email ='';
                this.firstname  ='';
                this.surname = '';
                this.age = 0;
                this.postcode  =0;
                this.gender  ='';
                this.country = '';
                this.state = '';
                this.lga = '';
                this.healthRating  =0;
                this.currentActivity  ='';
                this.currentBarrier  ='';
                this.culturalIdentity = false;
                this.registrationDate = new Date()
              }
                console.log("Registration Submitted")

            }
        },
    }

</script>

<style>

</style>